<template>
  <div class="content-wrapper remove_table_shadow">
    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    />

    <certificate-description-modal
      v-if="isDescriptionModalActive"
      :detail="descriptionDetail"
      @close-modal="closeDescriptionModal"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import * as actions from "../../../Config/ApiUrl";
import { TableHelpers } from "../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../core/helpers/app/AppFunction";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper.js";
import { Input } from "element-ui";
import CertificateDescriptionModal from "../Client/Buyer/Certificate/CertificateDescriptionModal.vue";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  components: {
    CertificateDescriptionModal,
  },
  props: {
    userId: Number,
  },
  data() {
    return {
      isDescriptionModalActive: false,
      descriptionDetail: {},
      isCertificateViewModalActive: false,
      certificateId: 0,
      companyId: 0,
      packages: {},
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      input: {},
      options: {
        name: "AdvanceTable",
        url: actions.USER_TRAINING_LIST+this.userId,
        showHeader: true,
        columns: [
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "title",
            modifier: (value, row) => {
              return `<span>${this.$t(row.display_title || value)}</span>`;
            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "description",
            modifier: (value, row) => {
              const triggerId = `assign-training-description-${row.id}`;
              this.bindDescriptionTrigger(triggerId, row);
              return `<button type="button" id="${triggerId}" class="btn btn-link p-0">${this.$t("view")}</button>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "user_certificates",
            modifier: (value) => {
              var status;
              if (value) {
                return `<span class="badge badge-sm badge-pill badge-success">${this.$t(value ? value.status : '---')}</span>`; 
              }
              else {
                return `<span>---</span>`;
              }

            },
          },
          {
            title: this.$t("issue_date"),
            type: "custom-html",
            key: "user_certificates",
            modifier: (value) => {
              return `<span>${this.$t(value ? value.issue_date : '---')}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "user_certificates",
            modifier: (value) => {
              return `<span>${this.$t(value ? value.due_date : '---')}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("assign"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  mounted() {
    setTimeout(() => {
      $( ".remove_table_shadow .h-100 .datatable .table-responsive " ).removeClass("shadow");
    }, 1000);
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
    },
    closeDescriptionModal() {
      $("#certificate-description-modal").modal("hide");
      this.isDescriptionModalActive = false;
      this.descriptionDetail = {};
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("assign")) {
        this.assignTraining(this.userId, rowData.id);
      }
    },
    assignTraining(user_id, certificate_id) {

      axiosPost(actions.ASSIGN_TRAINING, {userId:user_id, certificateId:certificate_id })
        .then((res) => {
          const message = res.data?.message || res.data;
          const type = res.data?.type || "success";

          if (type === "error") {
            this.$toastr.e(message);
          } else if (type === "applied") {
            this.$toastr.w(message);
          } else {
            this.$toastr.s(message);
          }

          this.$hub.$emit("reload-" + this.tableId);
        })
        .catch((error) => {
          this.$toastr.e(error?.response?.data?.message || error);
        });
    },
    openDescriptionModal(rowData) {
      this.descriptionDetail = rowData;
      this.isDescriptionModalActive = true;
    },
    bindDescriptionTrigger(triggerId, row) {
      setTimeout(() => {
        const trigger = document.getElementById(triggerId);
        if (trigger && !trigger.dataset.descriptionBound) {
          trigger.dataset.descriptionBound = "true";
          trigger.addEventListener("click", (event) => {
            event.preventDefault();
            this.openDescriptionModal(row);
          });
        }
      }, 0);
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        const searchSelectFilter = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        if (!searchSelectFilter) {
          return;
        }

        searchSelectFilter.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
  },
};
</script>
<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
